import React from 'react'
import VisitasListComponent from './VisitasListComponent';
import VisitasFormComponent from './VisitasFormComponent';

import estilos from './PanelVisitasFormComponent.module.css'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';


const PanelVisitasFormComponent = (props) => {


    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const inspectores = props.location.state.state.inspectores
    const domicilios = props.location.state.state.domicilios
    const dia = props.location.state.state.fechaSeleccionada.diaDelMes
    const mes = props.location.state.state.fechaSeleccionada.mes
    const ano = props.location.state.state.fechaSeleccionada.ano

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 700,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };


    return (
        <div className={`container`}><br />
            <div className='row'>
                <div className='col-8'>
                    <h2>Visitas del día {dia} de {mes} de {ano} </h2>
                </div>
                <div className='col-4'>
                    <button onClick={handleOpen} className='btn btn-success'>Agregar visita exclusiva</button>
                </div>

                <VisitasListComponent
                    dia={props.location.state.state.fechaSeleccionada.diaDelMes}
                    mes={props.location.state.state.fechaSeleccionada.mes}
                    ano={props.location.state.state.fechaSeleccionada.ano} />
            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <VisitasFormComponent
                        inspectores={props.location.state.state.inspectores}
                        domicilios={props.location.state.state.domicilios}
                        dia={props.location.state.state.fechaSeleccionada.diaDelMes}
                        mes={props.location.state.state.fechaSeleccionada.mes}
                        ano={props.location.state.state.fechaSeleccionada.ano} />


                </Box>
            </Modal>

        </div>
    )
}

export default PanelVisitasFormComponent